export default "__VITE_ASSET__CJWU6ZIi__"